<template>
  <div class="tabs-form">
    <div style="background: #ffffff;">
      <div class="tabs">
        <div @click="handleClick(item.id)" v-for="item in tabs" :key="item.id"
          :class="['tabs-pane', activeId === item.id && 'tabs-pane-avtive']" :_disabled="false">
          {{ item.name }}
        </div>
      </div>
      <el-form :inline="true" class="searchForm" ref="form" :model="form" v-if="activeId === 1 || activeId === 2">
        <div _flex="~ items-center">
          <el-form-item prop="title">
            <InputTopTip v-model="form.title" :placeholder="activeId === 1 ? '姓名' : '角色名称'">
              <el-input v-model="form.title" size="small" placeholder="" @keyup.native.enter="onSubmit()"></el-input>
            </InputTopTip>
          </el-form-item>
          <el-form-item prop="login_name" v-if="activeId === 1">
            <InputTopTip v-model="form.login_name" placeholder="账号">
              <el-input v-model="form.login_name" size="small" placeholder=""
                @keyup.native.enter="onSubmit()"></el-input>
            </InputTopTip>
          </el-form-item>
          <el-form-item prop="scope" v-if="activeId === 1">
            <InputTopTip v-model="form.scope" placeholder="所属层级">
              <el-cascader size="small" style="width:100%" v-model="form.scope" :options="levelData" placeholder=""
                :props="{
                  value: 'id',
                  label: 'title',
                  expandTrigger: 'click',
                  checkStrictly: true,
                  emitPath: false
                }" :show-all-levels="false" ref="cascader_2" @change="handleChange($event)"></el-cascader>
            </InputTopTip>
          </el-form-item>
          <el-form-item prop="identity" v-if="activeId === 1">
            <InputTopTip v-model="form.identity" placeholder="身份">
              <el-select v-model="form.identity" size="small" placeholder="" @change="handleChange($event)">
                <el-option v-for="item in identityOptions" :key="item.val" :label="item.name" :value="item.val">{{
                  item.name }}</el-option>
              </el-select>
            </InputTopTip>
          </el-form-item>
        </div>
        <div style="display: flex;margin-left: auto;align-items: center">
          <template>
            <el-button type="primary" @click="onSubmit" size="small" class="action-btn"
              style="width: 70px; margin-right: 15px;height: 32px;margin-right: 12px">搜索</el-button>
            <el-button type="primary" size="small"
              style="background: #f7f8fa; border: 1px solid #dcdcdc; color: #4b4b4b !important; width: 70px;height: 32px;margin-right: 12px"
              @click="resetForm('form')">重置</el-button>
          </template>
        </div>
      </el-form>

      <el-form :inline="true" class="searchForm" ref="levelform" :model="levelForm" v-if="activeId == 3">
        <div _flex="~ items-center">
          <el-form-item prop="title">
            <InputTopTip v-model="levelForm.title" :placeholder="'层级名称'">
              <el-input v-model="levelForm.title" size="small" @keyup.native.enter="handleSearch()"></el-input>
            </InputTopTip>
          </el-form-item>
        </div>

        <div style="display: flex;margin-left: auto;align-items: center">
          <template>
            <el-button type="primary" @click="handleSearch" size="small" class="action-btn"
              style="width: 70px;height: 32px;margin-right: 12px">搜索</el-button>
            <el-button type="primary" size="small"
              style="background: #f7f8fa; border: 1px solid #dcdcdc; color: #4b4b4b !important; width: 70px;height: 32px;margin-right: 12px"
              @click="resetForm('levelform')">重置</el-button>
          </template>
        </div>
      </el-form>
    </div>

    <div class="table" v-if="$permissions([SP8100]) && activeId == 1" style="background: #ffffff; margin-top: 8px;">
      <div class="table-header" v-if="$permissions([SP81001, SP81002])">
        <el-button type="primary" @click="Newbuttont" size="small" v-if="$permissions([SP81001]) && activeId == 1">
          <i class="el-icon-plus" style="margin-right: 7px;"></i>新建
        </el-button>

        <el-button type="primary" size="small" icon="el-icon-delete"
          :class="multipleSelection.length === 0 ? 'box' : 'box2'" :disabled="multipleSelection.length === 0"
          @click="batchDelete()"
          v-if="$permissions([SP81002]) && activeId == 1 && multipleSelection.length > 0">批量删除</el-button>
      </div>

      <el-table :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" ref="multipleTable"
        :key="tableKey" :header-cell-style="{ background: '#fafafa' }">
        <el-table-column type="selection" width="55" align="center"
          v-if="$permissions([SP81002]) && activeId == 1"></el-table-column>
        <el-table-column label="姓名" prop="realname"></el-table-column>
        <el-table-column label="账号" prop="login_name"></el-table-column>
        <el-table-column label="所属层级" prop="dept.department.title"></el-table-column>
        <el-table-column label="角色名称">
          <template v-slot:default="slot">
            <template v-for="(role, index) in slot.row.roles">
              <span :key="index">{{ role.display_name }}&nbsp;&nbsp;</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="身份" :formatter="data_scope2"></el-table-column>
        <el-table-column label="账号状态">
          <template v-slot:default="slot">
            <div style="display: flex; justify-content: left; align-items: center;">
              <span v-show="slot.row?.state == 0" style="margin-right: 5px;">
                <i class="dotClass" style="background-color: #67c23a;" _text="10px"></i>
              </span>
              <span v-show="slot.row?.state == 1" style="margin-right: 5px;">
                <i class="dotClass" style="background-color: #b81a19;"></i>
              </span>
              {{ slot.row?.state === 0 ? '使用中' : '已停用' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="dept.updated_at"></el-table-column>
        <el-table-column label="操作" align="center" v-if="$permissions([SP81003, SP81004])">
          <template v-slot:default="scope">
            <div class="table-mgn3">
              <div style="color: #3f6af7;" @click="Editbutton(scope.row.id, scope.row)" v-permission="SP81003">
                <el-tooltip content="编辑" placement="bottom" effect="light">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-iconoutlinesetting"></use>
                  </svg>
                </el-tooltip>
              </div>

              <div class="icon delete" style="color: #f13048;" @click="deleteRowClick(scope.row.id)"
                v-permission="SP81004">
                <el-tooltip content="删除" placement="bottom" effect="light">
                  <svg class="icon" aria-hidden="true"
                    style="width: 100%; height: 100%; outline: none; box-shadow: none;">
                    <use xlink:href="#icon-deltred"></use>
                  </svg>
                </el-tooltip>
              </div>
              <div v-show="$permissions(['SP81005']) && scope.row?.state == 0" class="icon delete"
                style="color: #f13048;" @click="resetState(scope.row.id)">
                <el-tooltip content="禁用" placement="bottom" effect="light">
                  <svg class="icon" aria-hidden="true"
                    style="width: 100%; height: 100%; outline: none; box-shadow: none;">
                    <use xlink:href="#icon-prohibit"></use>
                  </svg>
                </el-tooltip>
              </div>
              <div v-show="$permissions(['SP81005']) && scope.row?.state == 1" class="icon delete"
                style="color: #4ab96d;" @click="resetState(scope.row.id)">
                <el-tooltip content="启用" placement="bottom" effect="light">
                  <i aria-hidden="true" class="icon el-icon-circle-check"></i>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paginationuyt" v-if="$permissions([SP8100]) && activeId == 1">
      <div class="paginfont">总计：{{ total }}条/{{ Math.ceil(total / pageSize) }}页</div>
      <el-pagination :current-page.sync="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
        :total="total" background layout="prev, pager, next, jumper, sizes, slot" @current-change="handleCurrentChange"
        @size-change="handleSizeChange" :key="`${paginationKey}_${activeId}`">
      </el-pagination>
    </div>

    <div class="table" v-if="$permissions([SP8200]) && activeId == 2" style="background: #ffffff; margin-top: 8px;">
      <div class="table-header" v-if="$permissions([SP82001, SP82002])">
        <el-button type="primary" @click="Newbuttont" size="small" v-if="$permissions([SP82001]) && activeId == 2">
          <i class="el-icon-plus" style="margin-right: 7px;"></i>新建
        </el-button>

        <el-button type="primary" size="small" icon="el-icon-delete"
          :class="multipleSelection.length === 0 ? 'box' : 'box2'" :disabled="multipleSelection.length === 0"
          @click="batchDelete()"
          v-if="$permissions([SP82002]) && activeId == 2 && multipleSelection.length > 0">批量删除</el-button>
      </div>

      <el-table :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" ref="multipleTable"
        :key="tableKey" :header-cell-style="{ background: '#fafafa' }">
        <el-table-column type="selection" width="55" align="center"
          v-if="$permissions([SP82002]) && activeId == 2"></el-table-column>
        <el-table-column label="角色名称" prop="display_name" v-if="activeId === 2"></el-table-column>
        <!-- <el-table-column label="层级" prop="region.admin_level" v-if="activeId === 2" :formatter="admin_level"></el-table-column> -->
        <!-- <el-table-column label="所属辖区" prop="region.district_division" v-if="activeId === 2" :formatter="district_name"></el-table-column> -->
        <!-- <el-table-column label="数据范围" prop="region.data_scope" v-if="activeId === 2" :formatter="data_scope"></el-table-column> -->
        <el-table-column label="更新时间" prop="updated_at"></el-table-column>
        <el-table-column label="操作" align="center" v-if="$permissions([SP82003, SP82004, 'SP82005'])">
          <template v-slot:default="scope">
            <div class="table-mgn3">

              <div style="color: #3f6af7;" @click="LookButton(scope.row.id, scope.row)" v-permission="'SP82005'">
                <el-tooltip content="查看" placement="bottom" effect="light">
                  <i class="el-icon-view" style="color: #ff7143;"></i>
                </el-tooltip>
              </div>

              <div style="color: #3f6af7;" @click="Editbutton(scope.row.id, scope.row)" v-permission="SP82003">
                <el-tooltip content="编辑" placement="bottom" effect="light">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-iconoutlinesetting"></use>
                  </svg>
                </el-tooltip>
              </div>

              <div class="icon delete" style="color: #f13048;" @click="deleteRowClick(scope.row.id)"
                v-permission="SP82004">
                <el-tooltip content="删除" placement="bottom" effect="light">
                  <svg class="icon" aria-hidden="true"
                    style="width: 100%; height: 100%; outline: none; box-shadow: none;">
                    <use xlink:href="#icon-deltred"></use>
                  </svg>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paginationuyt" v-if="$permissions([SP8200]) && activeId == 2">
      <div class="paginfont">总计：{{ total }}条/{{ Math.ceil(total / pageSize) }}页</div>
      <el-pagination :current-page.sync="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
        :total="total" background layout="prev, pager, next, jumper, sizes, slot" @current-change="handleCurrentChange"
        @size-change="handleSizeChange" :key="`${paginationKey}_${activeId}`">
      </el-pagination>
    </div>

    <!-- 层级 -->
    <div class="table" v-if="activeId == 3" style="background: #ffffff; margin-top: 8px;">
      <div class="table-header">
        <el-button type="primary" @click="newLevel" size="small" v-if="activeId == 3 && $permissions(['SP83001'])">
          <i class="el-icon-plus" style="margin-right: 7px;"></i>新建
        </el-button>
      </div>
      <el-table v-if="activeId == 3" :data="levelData" style="width: 100%;margin-bottom: 20px" row-key="id"
        ref="treeTableRef" :row-class-name="tableRowClassName"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column prop="title" label="层级名称"></el-table-column>
        <el-table-column prop="updated_at" label="更新时间"></el-table-column>
        <el-table-column label="操作" v-if="$permissions(['SP83001', 'SP83002', 'SP83003'])">
          <div class="table-level" slot-scope="{ row, $index }">
            <div style="color: #3f6af7;" @click="newLevel(row)" v-if="$permissions(['SP83001'])">
              <el-tooltip content="添加" placement="bottom" effect="light">
                <i class="el-icon-plus" style="color:#FF5E2A" />
              </el-tooltip>
            </div>
            <div style="color: #3f6af7;background:#FAFBFF" @click="editLevel(row)" v-if="$permissions(['SP83002'])">
              <el-tooltip content="编辑" placement="bottom" effect="light">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-iconoutlinesetting"></use>
                </svg>
              </el-tooltip>
            </div>
            <div class="icon delete" style="color: #f13048;" v-if="$index != 0 && $permissions(['SP83003'])"
              @click="deleteLevel(row)">
              <el-tooltip content="删除" placement="bottom" effect="light">
                <svg class="icon" aria-hidden="true"
                  style="width: 100%; height: 100%; outline: none; box-shadow: none;">
                  <use xlink:href="#icon-deltred"></use>
                </svg>
              </el-tooltip>
            </div>
          </div>
        </el-table-column>
      </el-table>
    </div>


    <el-dialog class="practice-sheet-new-edit-dialog"
      :width="dialogTitleType === '新建账户' || dialogTitleType === '编辑账户' ? '540px' : '95%'"
      :top="dialogTitleType === '新建账户' || dialogTitleType === '编辑账户' ? '15vh' : '20px'" :close-on-click-modal="false"
      :visible.sync="practiceSheetNewEditDialog" @close="practiceSheetNewEditDialogClose">
      <div class="dialog-title2" slot="title">
        <span>{{ dialogTitleType }}</span>
        <el-divider></el-divider>
      </div>
      <template>
        <el-form :model="activeId == 1 ? accountModel : model" ref="newForm" :rules="vaRules"
          @submit.native.prevent="confirm">
          <el-form-item prop="name" v-if="dialogTitleType === '新建账户' || dialogTitleType === '编辑账户'">
            <InputTopTip v-model="accountModel.name" :placeholder="activeId == 1 ? '姓名' : '账户标识'">
              <el-input v-model="accountModel.name" style="width: 100%;" size="medium" :maxlength="10" :minlength="1" />
            </InputTopTip>
          </el-form-item>

          <div _flex="~ justify-between" v-if="dialogTitleType === '新建账户' || dialogTitleType === '编辑账户'">
            <el-form-item prop="scope">
              <InputTopTip v-model="accountModel.scope" placeholder="所属层级">
                <el-cascader size="medium" style="width:100%" v-model="accountModel.scope" :options="levelData"
                  placeholder="" :props="{
                    value: 'id',
                    label: 'title',
                    expandTrigger: 'click',
                    checkStrictly: true,
                    emitPath: false
                  }" :show-all-levels="false" ref="cascader_1"
                  @change="() => { $refs.cascader_1.dropDownVisible = false }"></el-cascader>
              </InputTopTip>
            </el-form-item>
            <el-form-item prop="roles">
              <InputTopTip v-model="accountModel.roles" placeholder="角色名称">
                <el-select clearable multiple v-model="accountModel.roles" size="medium" style="width: 100%;"
                  placeholder="">
                  <el-option v-for="item in roleList" :key="item.id" :label="item.display_name"
                    :value="item.id"></el-option>
                </el-select>
              </InputTopTip>
            </el-form-item>
          </div>
          <el-form-item prop="identity" v-if="dialogTitleType === '新建账户' || dialogTitleType === '编辑账户'">
            <div>请选择身份</div>
            <el-radio-group v-model="accountModel.identity">
              <el-radio v-for="item in identityOptions" :label="item.val" :key="item.val">{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="loginName" style="margin-top: 15px;"
            v-if="dialogTitleType === '添加角色' || dialogTitleType === '编辑角色'">
            <InputTopTip v-model="model.loginName" placeholder="角色名称">
              <el-input v-model="model.loginName" style="width: 100%;" size="medium" maxlength="10" minlength="1" />
            </InputTopTip>
          </el-form-item>
          <el-form-item v-if="dialogTitleType === '添加角色' || dialogTitleType === '编辑角色'">
            <div _text="16px bolder [#323232]" _m="b-10px">角色权限</div>
            <tableTree style="max-height:calc(100vh - 348px);overflow:auto" :data="SPRouter"
              :permissions="permissionsTree" :type="dialogTitleType" :visible="practiceSheetNewEditDialog"
              ref="tableTreeRef" />
            <!-- <el-tree
							:data="SPRouter"
							:props="defaultSPRouter"
							show-checkbox
							node-key="permission"
							:default-expanded-keys="defaultCheckRouter"
							:default-checked-keys="defaultCheckRouter"
							:check-on-click-node="true"
							ref="spRouter"
							@check="spRouterHandleCheckChange"
							style="max-height: 360px; overflow-y: auto;"
						>
						</el-tree> -->
          </el-form-item>

          <div style="margin-top: 23px;">
            <el-divider></el-divider>
          </div>
          <el-form-item
            style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
            <el-button class="btn-close" @click="practiceSheetNewEditDialogClose"
              style="width: 80px; height: 32px; line-height: 1px;">取 消</el-button>
            <el-button class="btn-prim" type="primary" native-type="submit"
              style="width: 80px; height: 32px; line-height: 1px;">{{ onTitleType }}</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="twoConfirmBoxFlag" width="30%" :before-close="beforeClose" class="dialog">
      <span slot="title" class="dialog-title">
        <i class="el-icon-warning-outline" style="margin-right: 12px;"></i>温馨提示
      </span>
      <div class="dialog-tip">是否删除该题目？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="twoConfirmBoxFlag = false" :disabled="loading">取 消</el-button>
        <el-button type="primary" @click="twoConfirmClick" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="practice-sheet-new-edit-dialog" width="540px" :close-on-click-modal="false"
      :visible.sync="levelVisible" @close="levelParamsClose">
      <div class="dialog-title2" slot="title">
        <span>{{ levelTitle }}</span>
        <el-divider></el-divider>
        <template>
          <el-form :model="levelParams" ref="levelParams" :rules="vaRules" @submit.native.prevent="levelConfirm">
            <el-form-item prop="name" style="margin-top: 25px;">
              <InputTopTip v-model="levelParams.name" placeholder="层级名称">
                <el-input v-model="levelParams.name" style="width: 100%;" size="medium" :maxlength="10"
                  :minlength="1" />
              </InputTopTip>
            </el-form-item>
            <el-form-item prop="scope">
              <InputTopTip v-model="levelParams.id" placeholder="上级层级">
                <el-cascader :disabled="levelParams.disabled" size="medium" style="width:100%" v-model="levelParams.id"
                  :options="levelData" placeholder="" :props="{
                    value: 'id',
                    label: 'title',
                    expandTrigger: 'click',
                    checkStrictly: true,
                    emitPath: false
                  }" :show-all-levels="false"></el-cascader>
              </InputTopTip>
            </el-form-item>
            <div style="margin-top: 23px;"><el-divider></el-divider></div>
            <el-form-item
              style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
              <el-button class="btn-close" style="width: 80px; height: 32px; line-height: 1px;"
                @click="levelVisible = false">取 消</el-button>
              <el-button class="btn-prim" type="primary" native-type="submit"
                style="width: 80px; height: 32px; line-height: 1px;">确认</el-button>
            </el-form-item>
          </el-form>
        </template>
      </div>
    </el-dialog>


    <el-dialog class="practice-sheet-new-edit-dialog" :width="'95%'" :top="'60px'" :close-on-click-modal="false"
      :visible.sync="LookModalVisible">
      <div class="dialog-title2" slot="title">
        <span>查看角色</span>
        <el-divider></el-divider>
      </div>
      <div @click="stopClick" _cursor="no-drop">
        <el-input disabled v-model="model.loginName" style="width: 100%;margin-bottom:15px" size="medium" maxlength="10"
          minlength="1" />
        <tableTree style="max-height:calc(100vh - 250px);overflow:auto;margin-bottom:15px;" :data="SPRouter"
          :permissions="permissionsTree" type="查看角色" :visible="practiceSheetNewEditDialog" ref="tableTreeRef" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  SP8100,
  SP81001,
  SP81002,
  SP81003,
  SP81004,
  SP8200,
  SP82001,
  SP82002,
  SP82003,
  SP82004
} from '@/utils/permissionMap.js'
import tableTree from './tableTree.vue'
import { mapValues, throttle } from 'lodash'
export default {
  components: { tableTree },
  props: {
    // 获取tabs标签数据接口
    getTabsApi: Function
  },
  data() {
    return {
      addressOptions: [],
      addressLevelOptions: [],
      schoolLevel: [
        { name: '省级', val: 1 },
        { name: '市级', val: 2 },
        { name: '区级', val: 3 }
      ],
      scopeAll: [
        { name: '全平台', val: 1 },
        { name: '同级', val: 2 },
        { name: '同级及子级', val: 3 }
      ],
      identityOptions: [
        { name: '所有者', val: 1 },
        { name: '管理员', val: 2 },
        { name: '团队成员', val: 3 }
      ],
      SP8100,
      SP81001,
      SP81002,
      SP81003,
      SP81004,
      SP8200,
      SP82001,
      SP82002,
      SP82003,
      SP82004,
      SPRouter: [],
      defaultSPRouter: {
        label: 'display_name',
        children: 'children'
      },
      defaultCheckRouter: [],
      spRouterKeys: [],
      spRouterVisble: false,
      currentPage: 1,
      total: 0,
      pageSize: 10,
      tabs: [],
      activeId: 1,
      tableKey: 0, //切换组件时改变key值
      form: {
        title: ''
      },
      tableData: [],
      multipleSelection: [],
      twoConfirmBoxFlag: false,
      row: {},
      loading: false,
      practiceSheetNewEditDialog: false, //设置新建弹窗
      dialogTitleType: '', //新建||编辑
      onTitleType: '', //确定||更新
      accountModel: { //账户表单
        name: '',
        roles: [],
        identity: '',
        scope: ''
      },
      model: {
        name: '',
        loginName: '',
        loginName1: '',
        setChecked: [],
        region_code: '',
        admin_level: '',
        data_scope: ''
      },
      vaRules: {
        name: [
          {
            required: true,
            message: '请输入账户名称',
            trigger: 'change'
          }
        ],
        scope: [{ required: true, message: '请选择所属层级', trigger: ['blur', 'change'] }],
        roles: [{ required: true, message: '请选择角色名称', trigger: ['blur', 'change'] }],
        identity: [{ required: true, message: '请选择身份', trigger: ['blur', 'change'] }],
        region_code: [{ required: true, message: '请选择辖区', trigger: ['blur', 'change'] }],
        admin_level: [{ required: true, message: '请选择层级', trigger: ['blur', 'change'] }],
        data_scope: [{ required: true, message: '请选择数据范围', trigger: ['blur', 'change'] }],
        // setChecked: [
        // 	{
        // 		validator: async (rule, value, callback) => {
        // 			await new Promise(resolve => setTimeout(resolve, 100))
        // 			if (this.model.setChecked.length <= 0) {
        // 				callback(new Error('权限列表至少选择一个'))
        // 			} else {
        // 				callback()
        // 			}
        // 		},
        // 		trigger: ['blur', 'change']
        // 	}
        // ],
        // value: [
        // 	{
        // 		validator: (rule, value, callback) => {
        // 			if (this.value.length === 0) {
        // 				callback(new Error('列表至少选择一个'))
        // 			} else {
        // 				callback()
        // 			}
        // 		},
        // 		trigger: 'change'
        // 	}
        // ],
        loginName: [
          {
            required: true,
            message: '请输入角色名称',
            trigger: 'change'
          }
        ],
        loginName1: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value) {
                if (/^[^\u4e00-\u9fa5]*$/.test(value)) {
                  callback()
                } else {
                  callback(new Error('不能包含中文字符'))
                }
              } else {
                callback(new Error('请输入登陆账号'))
              }
            },
            trigger: 'change'
          }
        ],
        // checkList: [
        // 	{
        // 		validator: (rule, value, callback) => {
        // 			if (this.checkList.length === 0) {
        // 				callback(new Error('角色至少选择一个'))
        // 			} else {
        // 				callback()
        // 			}
        // 		},
        // 		trigger: 'change'
        // 	}
        // ]
      },
      // checkList: [],
      roleList: [],
      EditId: null,
      value: [],
      selectTree: [],
      list: [],
      defaultProps: {
        children: 'child',
        label: 'display_name'
      },
      upResName: '',
      paginationKey: new Date().getTime(),
      levelForm: { // 组织架构 | 搜索
        title: ''
      },
      levelVisible: false, // 组织-弹框
      levelTitle: '新建组织架构', // 组织-弹框名字
      levelData: [], // 组织-数据
      levelParams: { // 组织-表单
        name: '',
        id: '',
        disabled: false
      },
      LookModalVisible: false, // 查看-弹框
      permissionsTree: [], // 编辑-选择权限
      highlightedRows: new Set() // 搜素
    }
  },
  created() {
    if (this.$permissions([SP8100])) {
      this.tabs.push({
        name: '账户列表',
        id: 1,
        permission: SP8100
      })
    }
    if (this.$permissions([SP8200])) {
      this.tabs.push({
        name: '角色设置',
        id: 2,
        permission: SP8200
      })
    }
    if (this.$permissions(['SP8300'])) {
      this.tabs.push({
        name: '组织架构',
        id: 3,
        permission: 'SP8300'
      })
    }
    this.$api.user.getPermissions().then(res => {
      this.SPRouter = this.removeNodesWithName(res, '列表')
      // this.SPRouter = res
    })
    if (this.$store.state.user.userInfo.type === this.$api.account.types.OTHER.value) {
      this.identityOptions.splice(0, 1)
    }
    this.RegionalLevel()
    this.getLevelData()
    try {
      this.getSearchParams()
      this.refreshDataList()
    } catch (err) {
      console.log('正常~')
      try {
        this.activeId = this.tabs[0].id
        this.refreshDataList()
      } catch (err) {
        throw new Error('获取不到activeId字段~')
      }
    }
  },
  methods: {
    admin_level(row) {
      try {
        return this.schoolLevel.find(item => item.val == row.region?.admin_level)?.name
      } catch (_) {
        return ''
      }
    },
    data_scope(row) {
      try {
        return this.scopeAll.find(item => item.val == row.region?.data_scope)?.name
      } catch (_) {
        return ''
      }
    },
    data_scope2(row) {
      try {
        return this.identityOptions.find(item => item.val == row.dept?.data_scope)?.name
      } catch (_) {
        return ''
      }
    },
    district_name(row) {
      try {
        if (row.region.admin_level == 1) {
          return `${row.region.district_division.l1_name}`
        } else if (row.region.admin_level == 2) {
          return `${row.region.district_division.l1_name}/${row.region.district_division.l2_name}`
        } else if (row.region.admin_level == 3) {
          return `${row.region.district_division.l1_name}/${row.region.district_division.l2_name}/${row.region.district_division.l3_name}`
        }
      } catch (_) {
        return ''
      }
    },
    stopClick(event) {
      event.stopPropagation();
      event.preventDefault();
    },
    removeEmptyItems(arr, name = 'child') {
      const newArr = []
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i]
        if (item[name]?.length >= 1) {
          item[name] = this.removeEmptyItems(item[name], name)
        } else {
          item[name] = undefined
        }
        newArr.push(item)
      }
      return newArr
    },
    async RegionalLevel() {
      const res = await this.$api.school.ssxlist(0)
      this.addressOptions = this.removeEmptyItems(res)
    },
    changeAdminLevel(level) {
      this.addressLevelOptions = this.recursiveChange(this.addressOptions, level)
      this.model.region_code = ''
    },
    recursiveChange(items, level) {
      return items.map(item => ({
        ...item,
        child: level > 1 ? this.recursiveChange(item.child || [], level - 1) : undefined
      }))
    },
    getSearchParams(top = undefined) {
      const searchParams = this.$store.state.searchParams[this.$route.name]
      if (top != undefined) {
        this.activeId = top
        this.currentPage = searchParams[top]?.page || 1
        this.pageSize = searchParams[top]?.page_size || 10
        this.form.title = searchParams[top]?.realname || searchParams[top]?.display_name || ''
        this.form.login_name = searchParams[top]?.login_name || ''
        this.form.identity = searchParams[top]?.data_scope || ''
        this.form.scope = searchParams[top]?.dept_id || ''
        // this.levelForm.title = searchParams[top]?.title || ''
      } else {
        const { historyTop } = searchParams
        this.activeId = historyTop
        this.currentPage = searchParams[historyTop]?.page
        this.pageSize = searchParams[historyTop]?.page_size
        this.form.title = searchParams[historyTop]?.realname || searchParams[historyTop]?.display_name
        // this.levelForm = searchParams[historyTop]?.title || ''
        this.form.login_name = searchParams[historyTop]?.login_name || ''
        this.form.identity = searchParams[historyTop]?.data_scope || ''
        this.form.scope = searchParams[historyTop]?.dept_id || ''
      }
      this.paginationKey = new Date().getTime()
    },
    spRouterAdd() {
      const ref = this.$refs['tableTreeRef']
      for (const key in ref.checkbox) {
        if (ref.checkbox[key]) {
          this.spRouterKeys.push(key)
        }
      }
      console.log(this.spRouterKeys, '2-1-21-21-21-21-')
      // const spRouter = this.$refs.spRouter
      // this.spRouterKeys = [...spRouter.getCheckedKeys(), ...spRouter.getHalfCheckedKeys()]
      // this.spRouterVisble = false
    },
    spRouterHandleCheckChange(data, checked) {
      this.$set(this.model, 'setChecked', checked.checkedKeys)
      if (data.item_type == 99) {
        const reg = /SP(\d{4})/
        let key
        if (data.permission.indexOf('_yy_') != -1) {
          key = data.permission.match(reg)[0] + '_yy_' + '99'
        } else if (data.permission.indexOf('_ms_') != -1) {
          key = data.permission.match(reg)[0] + '_ms_' + '99'
        } else {
          key = data.permission.match(reg)[0] + '99'
        }
        const keys = this.$refs.spRouter.getCheckedKeys()
        let flag
        if (data.permission == key) {
          if (keys.includes(key)) {
            flag = true
          } else {
            flag = false
          }
        } else {
          flag = true
        }
        this.$refs.spRouter.setChecked(key, flag)
      }
    },
    handleChange() {
      this.$refs.cascader_2.dropDownVisible = false
      this.currentPage = 1
      this.refreshDataList()
    },
    //获取列表数据
    async refreshDataList() {
      let res = null
      if (this.activeId === 1 && this.$permissions([SP8100])) {
        const params1 = {
          page: this.currentPage,
          page_size: this.pageSize,
          realname: this.form.title,
          login_name: this.form.login_name,
          data_scope: this.form.identity,
          dept_id: this.form.scope
        }
        this.$store.commit('setTabSearchParams', { key: this.$route.name, top: 1, params: params1 })
        res = await this.$api.version.list(params1)
      } else if (this.activeId === 2 && this.$permissions([SP8200])) {
        const params2 = {
          page: this.currentPage,
          page_size: this.pageSize,
          display_name: this.form.title
        }
        this.$store.commit('setTabSearchParams', { key: this.$route.name, top: 2, params: params2 })
        res = await this.$api.version.roleslist(params2)
      }
      if (this.activeId === 1 || this.activeId === 2) {
        this.total = res.meta.total
        this.tableData = res.data
      }

      if (this.activeId === 1 && this.$permissions([SP8200])) {
        let res2 = null
        res2 = await this.$api.version.roleslist({
          page_size: 999
        })
        this.roleList = res2.data
      }
      if (this.activeId === 2) {
        let res2 = null
        res2 = await this.$api.version.permissionslist({})
        this.list = res2
      }

      // 层级新的逻辑
      if (this.activeId == 3) {
        this.getLevelData()
      }
    },
    async getLevelData() {
      const data = await this.$api.version.getDept()
      if (data) {
        this.levelData = this.removeEmptyItems(data, 'children')
        if (this.levelData[0]?.children?.length > 0 && this.activeId == 3) {
          await new Promise((resolve) => setTimeout(() => resolve(), 100))
          this.expandParent(this.levelData[0]?.children[0])
        }
      }
    },
    practiceSheetNewEditDialogClose() {
      this.EditId = null
      this.practiceSheetNewEditDialog = false
      try {
        if (this.activeId === 2) {
          this.spRouterKeys = []
          // this.$refs.spRouter.setCheckedKeys([])
          // this.selectTree = []
          // this.value = []
          // this.$refs.tree.setCheckedNodes([])
        }
      } catch (err) {
        console.log(err)
      }
      this.model.name = ''
      this.model.loginName = ''
      this.model.loginName1 = ''
      // this.model.setChecked = []
      // this.model.admin_level = ''
      // this.model.region_code = ''
      // this.model.data_scope = ''
      // this.checkList = []
      this.$nextTick(() => {
        this.$refs['newForm'].resetFields()
      })
    },
    async Newbuttont() {
      if (this.activeId === 1) {
        this.practiceSheetNewEditDialog = true
        this.dialogTitleType = '新建账户'
        this.onTitleType = '确定'
        this.getLevelData()
        // 清空表单
        this.resetForm()
      } else if (this.activeId === 2) {
        this.practiceSheetNewEditDialog = true
        this.dialogTitleType = '添加角色'
        this.onTitleType = '确定'
        // 清空表单
        this.resetForm()
      }
    },
    LookButton: throttle(async function (id, row) {
      this.EditId = id
      let res = null
      res = await this.$api.version.rolesshow(id)
      const { display_name, permissions } = { ...res, ...row }
      this.permissionsTree = permissions
      this.model.loginName = display_name
      this.LookModalVisible = true
    }, 3000),
    //编辑
    Editbutton: throttle(async function (id, row) {
      if (this.activeId === 1) {
        await this.getLevelData()
        this.dialogTitleType = '编辑账户'
        this.onTitleType = '更新'
        this.practiceSheetNewEditDialog = true
        this.EditId = id
        let res = null
        res = await this.$api.version.show(id)
        this.accountModel.name = res.realname
        this.accountModel.scope = res.dept.dept_id
        this.accountModel.roles = res.roles?.length > 0 ? res.roles.map(item => item.id) : []
        this.accountModel.identity = res.dept.data_scope
      } else if (this.activeId === 2) {
        this.dialogTitleType = '编辑角色'
        this.onTitleType = '更新'
        this.EditId = id
        let res = null
        res = await this.$api.version.rolesshow(id)
        const { display_name, permissions } = { ...res, ...row }
        // const { district_division, admin_level, data_scope } = region
        // this.changeAdminLevel(admin_level)
        // const { l1_id, l2_id, l3_id } = district_division
        // this.model.region_code = admin_level == 1 ? [l1_id] : admin_level == 2 ? [l1_id, l2_id] : [l1_id, l2_id, l3_id],
        // this.model.name = name
        this.model.loginName = display_name
        this.permissionsTree = permissions
        this.practiceSheetNewEditDialog = true
        // this.model.admin_level = admin_level
        // this.model.data_scope = data_scope
        // this.spRouterKeys = this.defaultCheckRouter = permissions
        // 	.filter(item => {
        // 		if (['SP1000', 'SP7000'].includes(item.name) || item.item_type == 99) {
        // 			return item
        // 		}
        // 	})
        // 	.map(item => item.name)
      } 
      this.resetForm();
    }, 3000),
    async beforeClose(done) {
      if (this.loading) return
      done()
    },
    async twoConfirmClick() {
      this.loading = true
      const data = await new Promise(resolve => {
        setTimeout(() => {
          resolve(true)
        }, 2000)
      })
      if (data) {
        this.loading = false
        this.dialogVisible = false
      } else {
        console.log('error')
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    async handleClick(e) {
      if (this.activeId != e) {
        this.tableData = []
        this.multipleSelection = []
        this.tableKey = e
        this.getSearchParams(e)
        this.refreshDataList()
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      if (this.activeId === 3) {
        this.levelForm = mapValues(this.levelForm, () => '')
        this.highlightedRows.clear();
      } else {
        this.form = mapValues(this.form, () => '')
      }
      this.refreshDataList()
    },
    // 层级搜索
    onLevelSubmit() {
      this.$store.commit('setTabSearchParams', { key: this.$route.name, top: 3, params: this.levelForm })
      // 搜索定位到树形所在位置
    },
    onSubmit() {
      this.currentPage = 1
      this.refreshDataList()
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.refreshDataList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.refreshDataList()
    },
    async confirm() {
      if (this.activeId == 2) this.spRouterAdd()
      this.$refs['newForm'].validate(async valid => {
        if (valid) {
          try {
            if (this.activeId === 1) {
              if (this.onTitleType == '确定') {
                this.$api.version
                  .create({
                    realname: this.accountModel.name,
                    roles: this.accountModel.roles,
                    data_scope: this.accountModel.identity,
                    dept_id: this.accountModel.scope
                  })
                  .then(cRes => {
                    this.$message.success(`新建成功`)
                    this.practiceSheetNewEditDialogClose()
                    this.refreshDataList()
                  })
              } else if (this.onTitleType == '更新') {
                this.$api.version
                  .update(this.EditId, {
                    realname: this.accountModel.name,
                    roles: this.accountModel.roles,
                    data_scope: this.accountModel.identity,
                    dept_id: this.accountModel.scope
                  })
                  .then(cRes => {
                    this.$message.success(`${this.onTitleType}成功`)
                    this.practiceSheetNewEditDialogClose()
                    this.refreshDataList()
                  })
              }
            } else if (this.activeId === 2) {
              // let datalist = this.$refs.tree.getCheckedNodes()
              // let idse = datalist.map(item => item.id)
              if (this.onTitleType == '确定') {
                this.$api.version
                  .rolescreate({
                    // name: this.model.name,
                    display_name: this.model.loginName,
                    // region_code: Array.isArray(this.model.region_code) ? this.model.region_code[0] : this.model.region_code,
                    // admin_level: this.model.admin_level,
                    // data_scope: this.model.data_scope,
                    permissions: this.spRouterKeys
                  })
                  .then(cRes => {
                    this.$message.success(`新建成功`)
                    this.practiceSheetNewEditDialogClose()
                    this.refreshDataList()
                  })
              } else if (this.onTitleType == '更新') {
                this.$api.version
                  .rolesupdate(this.EditId, {
                    // name: this.model.name,
                    display_name: this.model.loginName,
                    // region_code: Array.isArray(this.model.region_code) ? this.model.region_code[0] : this.model.region_code,
                    // admin_level: this.model.admin_level,
                    // data_scope: this.model.data_scope,
                    permissions: this.spRouterKeys
                  })
                  .then(cRes => {
                    this.$message.success(`${this.onTitleType}成功`)
                    this.practiceSheetNewEditDialogClose()
                    this.refreshDataList()
                  })
              }
            }
          } catch (err) {
            console.log(err)
          }
        } else {
          console.log('error')
        }
      })
    },
    //删除
    deleteRowClick(row) {
      this.$confirm('此操作将永久删除该账号以及附属数据, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (this.activeId === 1) {
          await this.$api.version.delete(row)
        } else if (this.activeId === 2) {
          await this.$api.version.rolesdelete(row)
        }
        // 刷新
        this.refreshDataList()
      })
    },
    //批量删除数据
    batchDelete() {
      this.$confirm('此操作将永久删除该账号以及附属数据, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          let idse = this.multipleSelection.map(item => item.id)
          if (this.activeId === 1) {
            this.$api.version
              .Deletes({
                ids: idse
              })
              .then(cRes => {
                if (cRes.success === true) {
                  this.refreshDataList()
                }
              })
          } else if (this.activeId === 2) {
            this.$api.version
              .rolesDeletes({
                ids: idse
              })
              .then(cRes => {
                if (cRes.success === true) {
                  this.refreshDataList()
                }
              })
          }
        })
        .catch(() => { })
    },
    // 树形过滤某属性
    removeNodesWithName(data, targetName) {
      return data.filter(node => {
        if (node.display_name == targetName) {
          return false;
        }
        if (node.children) {
          node.children = this.removeNodesWithName(node.children, targetName);
        }
        return true;
      });
    },
    // 层级搜索
    handleSearch() {
      this.highlightedRows.clear();
      this.getLevelData()
      const query = this.levelForm.title.trim().toLowerCase();
      if (query) {
        this.searchAndHighlight(this.levelData, query);
      }
    },
    searchAndHighlight(data, query) {
      for (let item of data) {
        if (item.title.toLowerCase().includes(query)) {
          this.highlightedRows.add(item.id);
          this.expandParent(item);
        }
        if (item.children && item.children.length > 0) {
          this.searchAndHighlight(item.children, query);
        }
      }
    },
    expandParent(item) {
      let parent = this.findParent(this.levelData, item.id);
      while (parent) {
        this.$refs.treeTableRef.toggleRowExpansion(parent, true);
        parent = this.findParent(this.levelData, parent.id);
      }
    },
    findParent(data, id) {
      for (let item of data) {
        if (item.children && item.children.find(child => child.id === id)) {
          return item;
        } else if (item.children && item.children.length > 0) {
          const parent = this.findParent(item.children, id);
          if (parent) {
            return parent;
          }
        }
      }
      return null;
    },
    tableRowClassName(tableRow) {
      if (tableRow?.row?.id != undefined && this.highlightedRows.has(tableRow?.row?.id)) {
        return 'success-row';
      } else {
        return '';
      }
    },
    // 增删改
    async deleteLevel(row) {
      console.log(row, '删除')
      await this.$api.version.deleteDept(row.id)
      this.getLevelData()
    },
    newLevel(row) {
      this.levelTitle = '新增组织架构'
      if (row?.id) {
        this.levelParams.id = row.id
      }
      this.levelVisible = true
    },
    editLevel(row) {
      this.levelTitle = '编辑组织架构'
      this.levelVisible = true
      this.levelParams = { id: row.parent_id, eidtId: row.id, name: row.title, disabled: row.parent_id == 0 ? true : false }
    },
    levelParamsClose() {
      this.$refs.levelParams.resetFields()
      this.levelParams = mapValues(this.levelParams, () => '')
      this.levelParams.disabled = false
    },
    async levelConfirm() {
      if (this.levelTitle == '新增组织架构') {
        await this.$api.version.postDept({
          title: this.levelParams.name,
          parent_id: this.levelParams?.id || 0,
          sort: this.levelParams?.sort || 0
        })
      } else {
        await this.$api.version.putDept(this.levelParams.eidtId, {
          title: this.levelParams.name,
          parent_id: this.levelParams.id,
          sort: this.levelParams?.sort || 0
        })
      }
      await this.getLevelData()
      this.levelVisible = false
    },
    resetState(id) {
      this.$confirm('此操作将修改用户状态, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$api.version.putState(id)
        // 刷新
        this.refreshDataList()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.action-btn:focus {
  background-color: #ff5e2a;
  border-color: #ff5e2a;
  opacity: 1 !important;
}

.box {
  margin-right: 15px;
  background: #9f9f9f;
  border: 2px solid #f7f8fa;
  color: #4b4b4b !important;
}

.box:hover {
  margin-right: 15px;
  background: #9f9f9f;
  border: 2px solid #f7f8fa;
  color: #4b4b4b !important;
}

.box2 {
  margin-right: 15px;
  background: #f7f8fa;
  border: 2px solid #f7f8fa;
  color: #4b4b4b !important;
}

.setstyle {
  min-height: 120px;
  padding: 0 !important;
  margin: 0;
  overflow: auto;
  cursor: default !important;
}

/deep/.el-table {
  &.th.is-leaf,
  td {
    border-bottom: 1px solid #ebeef5;
  }
}

.tabs-form {
  min-height: 102px;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
}

.table {
  padding: 20px;
  display: block;
  min-height: 610px;
}

/deep/ .el-table tbody tr td:last-child {
  padding-right: 0 !important;
}

.persiom {
  /deep/ .el-dialog__body {
    max-height: 500px;
    overflow-y: auto;
  }
}

.dialog {
  /deep/ dialog-title {
    font-size: 18px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #323232;
  }

  /deep/ .el-dialog__body {
    border-top: 2px solid #f8f8f8;
    border-bottom: 2px solid #f8f8f8;
    margin: 1px 20px;
    max-height: 600px;
    overflow-y: auto;
  }

  /deep/ .el-dialog__footer {
    margin-top: 24px;
    margin-bottom: 25px;
  }
}

.dialog-tip {
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: bold;
  color: #323232;
  margin-top: 63px;
  margin-bottom: 52px;
  text-align: center;
}

.dialog-title {
  width: 70px;
  font-size: 18px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #d83a3a;
}

.paginationuyt {
  margin-top: 2px;
  background: #fff;
  padding: 15px 30px 15px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.paginfont {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.icon-circle {
  width: 28px;
  height: 28px;
  border-radius: 100%;
  background: #fff8f5;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.icon-circle:nth-child(2) {
  margin-left: 15px;
  margin-right: 15px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.tabs {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  height: 39px;
}

.tabs-pane-avtive {
  color: #4a4a4a !important;
  position: relative;
}

.tabs-pane-avtive::after {
  content: '';
  display: block;
  position: absolute;
  top: 38px;
  width: 74px;
  height: 2px;
  background: #ff5e2a;
  border-radius: 0px 0px 0px 0px;
}

.tabs-pane {
  margin-left: 17px;
  margin-right: 8px;
  width: 74px;
  height: 39px;
  font-size: 18px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #bbbbbb;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.searchForm {
  padding: 8px 0px 10px 19px;
  display: flex;
  justify-content: space-between;
  min-height: 46px;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
  }
}

.form-reset {
  display: flex;
  flex-wrap: nowrap;
}

.width-101 {
  width: 101px;
}

.width-166 {
  width: 166px;
}

.width-264 {
  width: 264px;
}

.table-level {
  width: 100% !important;
  display: flex;
  font-size: 16px;
  color: #999999;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  div {
    cursor: pointer;
    height: 28px;
    width: 28px;
    border: 1px solid #ebeef5;
    border-radius: 14px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.delete {
      border: 1px solid #fdeaec;
    }
  }
}

.dotClass {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
}
</style>

<style>
.success-row {
  background: #FFF8F5 !important;
}
</style>
